import React, { Component } from 'react';
import { appService } from '../../_services';
//import builder from 'xmlbuilder';
////var builder = require('xmlbuilder');
var parameters, SubscribersUser = [], SubscribedJournals = []
export class XMLgenerator extends Component {

    constructor(props) {
        super(props);
        //this.state = {
        //    UserData: [],
        //}
    }

    componentDidMount() {

        var self = this;
        appService.getAll('Product/GetSubscribedData')
            .then(function (data) {
                //   console.log(data)
                // self.setState({ UserData: data });
                //console.log(self.state.UserData);
            })
    }

    render() {
        return (
            <div></div>
        )
    }
}

export default XMLgenerator;


// WEBPACK FOOTER //
// ./src/components/Google_Scholar/XMLgenerator.js